export default () => {
	const toggle = document.querySelector(".primary-nav__toggle");
	const primaryNav = document.querySelector(".primary-nav .nav");
	const body = document.querySelector("body");
	const isiTray = document.querySelector('.isi-tray');
	if (toggle) {
		toggle.addEventListener("click", () => {
			toggle.classList.toggle("open");
			primaryNav.classList.toggle("active");
			body.classList.toggle('no-scroll');
			isiTray.classList.toggle('hidden-mnav');
		});
	}

	let currentPage = document.querySelector("body");
	let navItems = document.querySelectorAll(".primary-nav .nav__nav-item");

	if (currentPage) {
		for (let i = 0; i < navItems.length; i++) {
			let navLink = navItems[i].firstElementChild;
			let subnav = navLink.parentElement.parentElement.parentElement;
			let pageName = navLink.getAttribute("href").split("/").pop();
			if (currentPage.getAttribute("id") === pageName) {
				navItems[i].classList.add("active");
				if (subnav.classList.contains("has-subnav")) {
					subnav.classList.add("active");
				}
			}
		}
	}

	let anchors = document.querySelectorAll(".primary-nav .nav [href*='#']");
	if (window.matchMedia("(max-width: 991px)").matches) {
		for (let i = 0; i < anchors.length; i++) {
			anchors[i].addEventListener("click", () => {
				toggle.classList.toggle("open");
				primaryNav.classList.toggle("active");
			});
		}
	}

	if (currentPage.getAttribute("id") === "front") {
		class Header {
			constructor() {
				this.activeIndex = 0;
				this.navItems = document.querySelectorAll("[data-nav-id]");

				// define observer options
				const options = {
					root: null, // relative to document viewport
					rootMargin: "-2px", // margin around root. Values are similar to css property. Unitless values not allowed
					threshold: 1.0, // visible amount of item shown in relation to root
				};
				// configure intersection observer to track scroll progress throughout document
				this.observer = new IntersectionObserver(this.handleObserverIntersection.bind(this), options);
				// observe each header tag in document with intersection observer
				let sections = document.querySelectorAll(".scroll-tracker");

				sections.forEach((section) => {
					this.observer.observe(section);
				});
			}

			handleObserverIntersection(elements) {
				// current index must be memoized or tracked outside of function for comparison
				let localActiveIndex = this.activeIndex;

				// track which elements register above or below the document's current position
				const aboveIndeces = [];
				const belowIndeces = [];

				// loop through each intersection element
				//  due to the asychronous nature of observers, callbacks must be designed to handle 1 or many intersecting elements
				elements.forEach((element) => {
					// detect if intersecting element is above the browser viewport; include cross browser logic
					const boundingClientRectY = typeof element.boundingClientRect.y !== "undefined" ? element.boundingClientRect.y : element.boundingClientRect.top;
					const rootBoundsY = typeof element.rootBounds.y !== "undefined" ? element.rootBounds.y : element.rootBounds.top;
					const isAbove = boundingClientRectY < rootBoundsY;

					// get index of intersecting element from DOM attribute
					const intersectingElemIdx = parseInt(element.target.getAttribute("data-id"));

					// record index as either above or below current index
					if (isAbove) aboveIndeces.push(intersectingElemIdx);
					else belowIndeces.push(intersectingElemIdx);
				});

				// determine min and max fired indeces values (support for multiple elements firing at once)
				const minIndex = Math.min.apply(Math, belowIndeces);
				const maxIndex = Math.max.apply(Math, aboveIndeces);

				// determine how to adjust localActiveIndex based on scroll direction
				if (aboveIndeces.length > 0) {
					// scrolling down - set to max of fired indeces
					localActiveIndex = maxIndex;
				} else if (belowIndeces.length > 0 && minIndex <= this.activeIndex) {
					// scrolling up - set to minimum of fired indeces
					localActiveIndex = minIndex - 1 >= 0 ? minIndex - 1 : 0;
				}

				// render new index to DOM (if required)
				if (localActiveIndex != this.activeIndex) {
					this.activeIndex = localActiveIndex;
				}

				this.render();
			}

			render() {
				let activeIndex = document.querySelectorAll("li.active.nav__nav-item");
				if (activeIndex.length > 0) {
					activeIndex[0].classList.remove("active");
				}
				let navList = document.querySelectorAll("[data-nav-id]");
				if (this.activeIndex !== 0 && this.activeIndex !== 6) {
					navList[this.activeIndex - 1].classList.add("active");
				}
			}
		}

		new Header();
	}
};
